import { connect } from 'react-redux';
import {
    toggleFilterSettingsModal,
    setSelectedFilters,
    refreshFilters,
} from "../../redux/pushMessages/actions";
import { getAppointmentTypes } from '../../redux/appointmentTypes/actions';
import { FilterSettingsModal } from './FilterSettingsModal';

const mapStateToProps = (state) => ({
    filterSettingsModalIsOpen: state.pushMessagesReducer.filterSettingsModalIsOpen,
    selectedFilters: state.pushMessagesReducer.selectedFilters,
    appointmentTypes: state.appointmentTypesReducer.appointmentTypes,
});

const mapDispatchToProps = {
    toggleFilterSettingsModal,
    setSelectedFilters,
    refreshFilters,
    getAppointmentTypes,
};

export default connect(mapStateToProps, mapDispatchToProps)(FilterSettingsModal);